export const locationByAisleByActiveBySortKey = /* GraphQL */ `
  query LocationByAisleByActiveBySortKey(
    $aisleId: ID
    $activeSortKey: ModelLocationLocationByAisleByActiveBySortKeyCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationByAisleByActiveBySortKey(
      aisleId: $aisleId
      activeSortKey: $activeSortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          totalLocations
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
          locationLoad {
            other {
              selected
              capacity
            }
            pallet {
              selected
              capacity
            }
            box {
              selected
              capacity
            }
            container {
              selected
              capacity
            }
            superSack {
              selected
              capacity
            }
            dryBulk {
              selected
              capacity
            }
            liquidBulk {
              selected
              capacity
            }
          }
        }
        bay
        level
        position
        locationLoad {
          other {
            selected
            capacity
          }
          pallet {
            selected
            capacity
          }
          box {
            selected
            capacity
          }
          container {
            selected
            capacity
          }
          superSack {
            selected
            capacity
          }
          dryBulk {
            selected
            capacity
          }
          liquidBulk {
            selected
            capacity
          }
        }
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
        isContaminated
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
